export class OutboundEmailsModel {
  id?: number;
  bcc?: string;
  bounced: boolean;
  bouncedAt?: Date;
  cc?: string;
  clicked: boolean;
  delivered: boolean;
  deliveredAt?: Date;
  emailSettingId: number;
  externalEmailId: string;
  firstClickedAt?: Date;
  firstOpenedAt?: Date;
  fromAddress: string;
  opened: boolean;
  recipients: string;
  sentAt: Date;
  subject: string;
  templateParams: Record<string, unknown>;

  failureReason?: string;
  emailType: string;
  invoiceIds: number[];

  actionDefId?: number;
  actionDefInstanceId?: number;
  outboundEmailId?: number;
  useCaseInstanceId?: number;
}

export enum OutboundEmailStatus {
  SENDING = 'SENDING',
  DELIVERED = 'DELIVERED',
  OPENED = 'OPENED',
  CLICKED = 'CLICKED',
  BOUNCED = 'BOUNCED',
  RESOLVED = 'RESOLVED',
  MIXED = 'MIXED',
}

export interface OutboundEmailRow extends OutboundEmailsModel {
  status?: OutboundEmailStatus;
  clientNames?: string;
  clientIds?: string;
  clientGroupNames?: string;
  clientPartnerNames?: string;
  clientManagerNames?: string;
  officeNames?: string;
  attachmentNames?: string;
  openedAt?: Date;
  clickedAt?: Date;
  recipientDetails?: OutboundEmailRow[];
  hasChildren?: boolean;
  level?: number;
}
